module.exports = __webpack_public_path__ + "static/techinasia-tokped-2f4ed64d24921b4c9e52db2c937f55b9.jpg";